'use client';
import Image from 'next/image';
import React from 'react';
import Button from '../ui/button';
import { usePostHogEvents } from '@/hooks/usePostHogEvents';
import { getThemeClass } from '@/helpers/theme';

interface SingleBanner {
  title: string;
  desc: string;
  image: string;
  mobile_image?: string;
  btn_text: string;
  btn_url: string;
  btn_color: string;
  has_cta: boolean;
  theme?: 'dark' | 'light';
}

const SingleBanner = ({
  title,
  desc,
  image,
  mobile_image,
  btn_text,
  btn_url,
  btn_color,
  has_cta,
  theme = 'dark',
}: SingleBanner) => {
  const { sendButtonClickEvent } = usePostHogEvents();

  return (
    <div
      className={`h-[600px] md:h-[750px] lg:rounded-[10px]  overflow-hidden  w-full flex flex-col md:justify-start justify-center items-center relative`}
    >
      {mobile_image ? (
        <>
          <Image
            src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/${mobile_image}`}
            alt={title}
            title={title}
            fill
            loading="lazy"
            sizes="(max-width: 639px) 100vw, 0px"
            className="w-full h-full object-cover select-none block sm:hidden"
          />
          <Image
            src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/${image}`}
            alt={title}
            title={title}
            fill
            loading="lazy"
            sizes="(max-width: 639px) 0px, (max-width: 1200px) 100vw, 1280px"
            className="w-full h-full object-cover select-none hidden sm:block"
          />
        </>
      ) : (
        <Image
          src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/${image}`}
          alt={title}
          title={title}
          fill
          loading="lazy"
          sizes="(max-width: 1200px) 100vw, 1280px"
          className="w-full h-full object-cover select-none"
        />
      )}

      <div
        className={`w-full h-full justify-between md:justify-start z-10 px-4 text-center flex flex-col gap-3 lg:gap-3 items-center md:pt-24 pt-14 pb-14 md:pb-16 transition-transform slider-content `}
      >
        <span className="flex flex-col gap-3">
          <h1
            className={`font-bold ${getThemeClass(theme, 'heading')} text-2xl leading-[32px] md:text-[32px] md:leading-[48px]`}
          >
            {title}
          </h1>
          <p
            className={`md:text-[18px] text-[16px] font-proxima_font ${getThemeClass(theme, 'text')}`}
          >
            {desc}
          </p>
        </span>
        {has_cta && (
          <Button
            onClick={() => {
              sendButtonClickEvent(btn_text, title);
            }}
            label={(btn_text + '>') as string}
            color={btn_color ?? 'white'}
            to={btn_url ?? '/'}
            className="text-[14px] font-semibold mt-4 font-proxima_font"
          />
        )}
      </div>
    </div>
  );
};

export default SingleBanner;
